import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { KbError } from '../api/client'

/**
 * 统一错误条：展示 code / trace_id / 降级计划（技术方案 §5.1、§5.4）。
 * 不用弹窗打断长任务处理流程；文案给出可执行的下一步。
 */
export default function TraceBanner() {
  const [problem, setProblem] = useState<KbError | null>(null)
  const location = useLocation()

  useEffect(() => {
    const onError = (event: Event) => setProblem((event as CustomEvent<KbError>).detail)
    window.addEventListener('kb:error', onError)
    return () => window.removeEventListener('kb:error', onError)
  }, [])

  // 错误只属于触发它的页面/操作；切换菜单或内容库目录后不继续污染新的工作流。
  useEffect(() => {
    setProblem(null)
  }, [location.pathname, location.search])

  if (!problem) return null

  const tone = problem.status >= 500 || problem.retryable ? 'danger' : 'warn'
  return (
    <div className={`errorbar ${tone}`} role="alert" aria-live="assertive">
      <span className="mono">{problem.code}</span>
      <span className="grow">{problem.message}</span>
      <span className="mono muted" title="交给运营时请提供该 trace_id">trace {problem.traceId}</span>
      {problem.degrade && problem.degrade !== '—' ? <span className="muted">降级：{problem.degrade}</span> : null}
      <button type="button" className="btn ghost" onClick={() => setProblem(null)}>关闭</button>
    </div>
  )
}
